import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getSubsidiaries = async ({ commit }) => {
  let url = `/subsidiaries/selectable`;

  await connection.get(url)
    .then(res => {
      const subsidiaries = res.data.data;
      commit('setSubsidiariesSelectable', subsidiaries);
    }).catch(err => {
      console.log('error', err);
    });
}

export const loadSubsidiaries = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setSubsidiaryIsLoading', true);
    let url = `/subsidiaries`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        const subsidiaries = res.data.data;
        commit('setSubsidiaries', subsidiaries);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setSubsidiariesPaginated', res.data);
        commit('setSubsidiaryIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setSubsidiaryIsLoading', false);
      });
}

export const subsidiaryById = async ({ commit }, id) => {
  commit('setSubsidiaryIsLoading', true);
  await connection.get(`/subsidiaries/${id}`)
    .then(res => {
      commit('setSubsidiaryDetail', res.data.data);
      commit('setSubsidiaryIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setSubsidiaryIsLoading', false);
    });
}

export const storeSubsidiary = async ({ commit }, subsidiary) => {
  console.log(subsidiary);
  commit('setSubsidiaryIsCreating', true);
  await connection.post(`/subsidiaries/create`, subsidiary)
    .then(res => {
      console.log(res.data);
      commit('saveNewSubsidiaries', res.data);
      commit('setSubsidiaryIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setSubsidiaryIsCreating', false);
    });
}

export const updateSubsidiary = async ({ commit }, subsidiary ) => {
  commit('setSubsidiaryIsUpdating', true);
  await connection.put(`/subsidiaries/${subsidiary.id}/update`, subsidiary)
    .then(res => {
      commit('saveUpdatedSubsidiary', res.data);
      commit('setSubsidiaryIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setSubsidiaryIsUpdating', false);
    });
}

export const deleteSubsidiary = async ({ commit }, subsidiary) => {
  commit('setSubsidiaryIsDeleting', true);
  await connection.delete(`/subsidiaries/${subsidiary.id}/delete`)
    .then(res => {
      commit('setDeleteSubsidiary', res.data);
      commit('setSubsidiaryIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setSubsidiaryIsDeleting', false);
    });
}
